module.exports = __webpack_public_path__ + "r-v3/img/ico_toast_content.ef775234.svg";